export enum ConsumerRoutes {
	LiveHaggles = '/',
	Profile = '/customer/profile',
	AddProfile = '/customer/profile/add',
	Notifications = '/customer/notifications',
}
